import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-4 py-12 text-center text-white/65" data-id="element-88" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-89" data-mp="3ggaovpzpm32t">
        <p className="font-serif text-2xl text-white" data-id="element-90" data-mp="3gh3qydnq44em">Système des Constellations Familiales™</p>
        <p className="mt-3 text-sm font-semibold text-white/80" data-id="element-91" data-mp="32lrnnhvi55m3">
          Le système de guérison par Constellations Familiales le plus complet en français.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-92" data-mp="3ugboz385h6h8">
          Parce que la guérison générationnelle mérite un vrai système professionnel.
        </p>
        <p className="mt-6 text-sm" data-id="element-93" data-mp="3lem1g8he2roq">
          📧{' '}
          <a className="transition-colors duration-200 hover:text-amber" href="mailto:support@eurekalabs.com" data-id="element-94" data-mp="3ldu874b9l61m">
            support@eurekalabs.com
          </a>{' '}
          <span className="mx-2 text-white/30" data-id="element-95" data-mp="29yxcxcohlklt">·</span> 🌐 www.eurekalabs.store
        </p>
        <p className="mt-6 text-xs" data-id="element-96" data-mp="2eyt7ymf7i1p8">
          © Système des Constellations Familiales™ 2026 — Tous droits réservés.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-97" data-mp="3labrlvxno6qd">
          Ce produit est un téléchargement numérique. Les résultats peuvent varier. Ce système ne remplace pas un avis
          médical ou psychologique professionnel.
        </p>
      </div>
    </footer>;
}